<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xml:space="preserve"
    width="128px"
    height="128px"
    version="1.1"
    style="
      shape-rendering: geometricPrecision;
      text-rendering: geometricPrecision;
      image-rendering: optimizeQuality;
      fill-rule: evenodd;
      clip-rule: evenodd;
    "
    viewBox="0 0 128 128"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
  >
    <defs></defs>
    <g id="Camada_x0020_1">
      <metadata id="CorelCorpID_0Corel-Layer" />
      <g id="_2676354669264">
        <path
          class="fil0"
          d="M6.605 36.222l-6.605 0 0 84.434c0,4.025 3.326,7.344 7.373,7.344l71.435 0 0 -6.693 -72.203 0 0 -85.085z"
        />
        <path
          class="fil0"
          d="M94.164 6.552l-29.147 0c-0.002,-3.618 -2.943,-6.552 -6.569,-6.552 -3.623,0 -6.566,2.934 -6.568,6.552l-29.149 0c-4.51,0 -8.22,3.694 -8.22,8.197l0 95.05c0,4.496 3.708,8.196 8.22,8.196l51.766 0c-2.959,-1.577 -5.644,-3.6 -7.963,-5.98l-45.451 0 0 -92.351 74.735 0 0 38.288c2.283,0.442 4.481,1.124 6.566,2.02l0 -45.223c0,-4.505 -3.713,-8.197 -8.22,-8.197zm-35.71 -3.274c1.816,0 3.285,1.467 3.285,3.277 0,1.812 -1.469,3.28 -3.285,3.28 -1.814,0 -3.283,-1.468 -3.283,-3.28 0,-1.81 1.469,-3.277 3.283,-3.277z"
        />
        <path
          class="fil0"
          d="M27.651 88.556l29.767 0c-0.011,0.336 -0.018,0.672 -0.018,1.01 0,1.893 0.165,3.745 0.479,5.547l-30.228 0 0 -6.557z"
        />
        <path
          class="fil0"
          d="M27.651 62.32l44.806 0c-2.834,1.787 -5.37,4.003 -7.516,6.556l-37.29 0 0 -6.556z"
        />
        <path
          class="fil0"
          d="M27.651 75.433l33.015 0c-1.014,2.07 -1.811,4.265 -2.365,6.555l-30.65 0 0 -6.555z"
        />
        <polygon
          class="fil0"
          points="57.113,45.929 89.131,45.929 89.131,52.484 57.113,52.484 "
        />
        <polygon
          class="fil0"
          points="57.113,32.77 89.131,32.77 89.131,39.325 57.113,39.325 "
        />
        <path
          class="fil0"
          d="M39.098 45.966l-2.349 -0.002c-3.648,-0.002 -9.098,1.654 -9.098,5l0 1.555 11.447 -0.072 11.447 0.072 0 -1.555c0,-3.346 -5.452,-5.002 -9.098,-5l-2.349 0.002z"
        />
        <path
          class="fil0"
          d="M39.1 42.609c-1.382,0 -2.547,-0.475 -3.499,-1.427 -0.952,-0.951 -1.43,-2.113 -1.43,-3.492 0,-1.378 0.478,-2.539 1.43,-3.491 0.952,-0.951 2.117,-1.425 3.499,-1.425 1.376,0 2.543,0.474 3.493,1.425 0.954,0.952 1.43,2.113 1.43,3.491 0,1.379 -0.476,2.541 -1.43,3.492 -0.948,0.952 -2.117,1.427 -3.493,1.427z"
        />
        <path
          class="fil0"
          d="M89.653 72.603c9.382,0 16.998,7.596 16.998,16.963 0,9.365 -7.616,16.969 -16.998,16.969 -9.384,0 -16.997,-7.604 -16.997,-16.969 0,-9.367 7.613,-16.963 16.997,-16.963zm22.699 32.089l15.648 15.244 -7.372 7.546 -15.835 -15.248c-4.332,2.89 -9.539,4.576 -15.14,4.576 -15.074,0 -27.293,-12.2 -27.293,-27.244 0,-15.046 12.219,-27.245 27.293,-27.245 15.07,0 27.294,12.199 27.294,27.245 0,5.596 -1.694,10.798 -4.595,15.126z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconEnvioApp',
}
</script>

<style></style>
